import React from "react";
import { motion } from "framer-motion";
import { PROFILE } from "../lib/data";
import { Mail, Phone, Linkedin, ArrowUpRight } from "lucide-react";

export const Contact = () => {
  const items = [
    { icon: Mail, label: "Email", value: PROFILE.email, href: `mailto:${PROFILE.email}`, testid: "contact-email" },
    { icon: Phone, label: "Phone", value: PROFILE.phone, href: `tel:${PROFILE.phone.replace(/\s/g, "")}`, testid: "contact-phone" },
    { icon: Linkedin, label: "LinkedIn", value: "Connect on LinkedIn", href: PROFILE.linkedin, testid: "contact-linkedin" },
  ];

  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 bg-secondary/40 border-t border-black/5">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="overline text-primary mb-4">Contact</p>
          <h2 className="font-serif text-3xl md:text-5xl text-foreground leading-tight">
            Let&apos;s build something thoughtful together.
          </h2>
          <p className="mt-6 text-lg text-foreground/70 leading-relaxed">
            I&apos;m open to <span className="text-foreground font-medium">Senior UX Designer</span>,{" "}
            <span className="text-foreground font-medium">Product Designer</span>, and{" "}
            <span className="text-foreground font-medium">UI/UX Designer</span> opportunities.
          </p>
        </div>

        <div className="md:col-span-6 md:col-start-7 space-y-4">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
            <motion.a
              key={it.label}
              href={it.href}
              target={it.label === "LinkedIn" ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={it.testid}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.06 }}
              className="group flex items-center justify-between rounded-2xl border border-black/5 bg-white p-6 card-shadow hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary text-primary">
                  <Icon size={18} />
                </span>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-primary/70">{it.label}</div>
                  <div className="text-foreground">{it.value}</div>
                </div>
              </div>
              <ArrowUpRight size={18} className="text-foreground/30 group-hover:text-primary transition-colors" />
            </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
